
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[tab]",
      function () {
        return require("private-next-pages/home/[tab]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[tab]"])
      });
    }
  